import CloseIcon from "@mui/icons-material/Close";
import { Player } from "@lottiefiles/react-lottie-player";
import ratingAndReview from "../../../assets/animation/ratingAndReview.json";

export default function FeedbackView({ onClose, reviewDetails = {} }) {
  const labels = {
    1: "Very Bad",
    2: "Bad",
    3: "Okay",
    4: "Good",
    5: "Excellent",
  };

  return (
    <div className="bg-white rounded-xl shadow p-4 md:col-span-2 ">
      <div className="flex justify-between items-center">
        <h3 className="font-semibold text-lg">Cusomer Rating</h3>
        <button
          onClick={onClose}
          className="text-gray-600 hover:text-black"
          aria-label="Close"
        >
          <CloseIcon />
        </button>
      </div>

      {/* ✅ Lottie Animation */}
      <Player
        autoplay
        loop
        src={ratingAndReview}
        style={{ height: "200px", width: "200px" }}
      />
      <div className="flex flex-col space-y-4 pb-4">
        <div className="flex flex-col items-center text-center">
          <div className="text-2xl font-semibold text-green-600">
           {labels[reviewDetails.score] }!
          </div>
          <div className="flex mt-1">
            {[1, 2, 3, 4, 5].map((star) => (
              <span
                key={star}
                className={`text-2xl ${
                  star <= reviewDetails.score
                    ? "text-yellow-400"
                    : "text-gray-300"
                }`}
              >
                ★
              </span>
            ))}
          </div>
        </div>

        <div className="relative border-l-4 border-blue-400 bg-gradient-to-r from-blue-50 to-white shadow rounded-md p-3 pl-4">
          <div className="absolute -left-3 -top-3 bg-blue-400 text-white text-[10px] px-2 py-[2px] rounded-full">
            Customer Feedback
          </div>
          <div className="text-gray-800 text-sm">{reviewDetails.content}</div>
            <div className="text-xs text-gray-500 mt-1 text-right">
              14/07/2009
            </div>
        </div>
      </div>
    </div>
  );
}
